import { zlbBudgetConfigProjectScenesConfigListPost } from '@/api/zlbBudget';
import {
  createOtherFundProject,
  createOtherFundProjectType,
  deleteOtherFundProject,
  deleteOtherFundProjectType,
  editOtherFundProject,
  editOtherFundProjectType,
  getOtherFundProjectPageList,
  getOtherFundProjectProjectDetail,
  getOtherFundProjectTypeDetail,
  getOtherFundProjectTypeDownList,
  getTemplateZlbBudgetImportGet,
  resultZlbBudgetImportPost,
  submitZlbBudgetImportPost,
} from '@/routes/OtherFundsOfTheUnit/services';
import {
  addBudgetProject,
  addBudgetProjectType,
  deleteBudgetProject,
  deleteBudgetProjectType,
  editBudgetProject,
  editBudgetProjectType,
  enableProjectLibrary,
  getBudgetDepList,
  getBudgetProjectDetail,
  getBudgetProjectList,
  getBudgetProjectReportList,
  getBudgetProjectTypeDetail,
  getBudgetProjectTypeDownList,
  getBudgetProjectTypeList,
  getBudgetUserList,
  getCurrentOperatorDepHierarchy,
  getCurrentOperatorFundDepList,
  getProjectImportTemplate,
  getProjectLibrarySwitchOpenable,
  getProjectLibrarySwitchStatus,
  handleProjectImportResult,
  projectBindVirtualTeam,
  relateProjectFinance,
  savelBudgetLimitPerson,
  submitProjectImport,
} from '../services';

const formatData = (data = [], key, disabled?) => {
  return (data || [])?.map(i => ({
    title: i.name,
    value: i[key],
    key: i[key],
    disabled: disabled !== undefined ? disabled : !i.enable,
    ...i,
    children: i.children && i.children.length > 0 ? formatData(i.children, key, disabled) : null,
  }));
};

export default {
  namespace: 'budgetProject',
  state: {
    projectTypeTreeList: [],
    budgetProjectDepList: [],
    projectDetailControl: null,
    assistedReportControl: null,
  },
  effects: {
    // 获取预算项目列表
    *getBudgetProjectList({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? getOtherFundProjectPageList : getBudgetProjectList;
      return yield call(serviceReq, payload);
    },
    // 获取预算项目详情
    *getBudgetProjectDetail({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? getOtherFundProjectProjectDetail : getBudgetProjectDetail;
      return yield call(serviceReq, payload);
    },

    // 新增项目
    *addBudgetProject({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? createOtherFundProject : addBudgetProject;
      return yield call(serviceReq, payload);
    },

    // 编辑项目
    *editBudgetProject({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? editOtherFundProject : editBudgetProject;
      return yield call(serviceReq, payload);
    },
    // 删除项目
    *deleteBudgetProject({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? deleteOtherFundProject : deleteBudgetProject;
      return yield call(serviceReq, payload);
    },
    // 获取类型列表
    *getBudgetProjectTypeList({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? getOtherFundProjectTypeDownList : getBudgetProjectTypeList;
      return yield call(serviceReq, payload);
    },
    // 获取类型下拉列表
    *getBudgetProjectTypeDownList({ payload }, { call, put }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds
        ? getOtherFundProjectTypeDownList
        : getBudgetProjectTypeDownList;
      const result = yield call(serviceReq, payload);
      yield put({
        type: 'update',
        payload: {
          projectTypeTreeList: formatData(result?.typeTreeList, 'uk'),
        },
      });
    },
    // 删除项目类型
    *deleteBudgetProjectType({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? deleteOtherFundProjectType : deleteBudgetProjectType;
      return yield call(serviceReq, payload);
    },
    // 获取类型详情
    *getBudgetProjectTypeDetail({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? getOtherFundProjectTypeDetail : getBudgetProjectTypeDetail;
      return yield call(serviceReq, payload);
    },
    // 添加项目类型
    *addBudgetProjectType({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? createOtherFundProjectType : addBudgetProjectType;
      return yield call(serviceReq, payload);
    },
    // 编辑项目类型
    *editBudgetProjectType({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? editOtherFundProjectType : editBudgetProjectType;
      return yield call(serviceReq, payload);
    },
    // 获取人员列表
    *getBudgetUserList({ payload }, { call }) {
      return yield call(getBudgetUserList, payload);
    },
    // 获取部门列表
    *getBudgetDepList({ payload }, { call, put }) {
      const result = yield call(getBudgetDepList, payload);
      const depList = formatData(result?.depList, 'id', false);
      yield put({
        type: 'update',
        payload: {
          budgetProjectDepList: depList,
        },
      });

      return depList;
    },
    // 获取申报项目列表
    *getBudgetProjectReportList({ payload }, { call }) {
      return yield call(getBudgetProjectReportList, payload);
    },
    // 提交项目导入
    *submitProjectImport({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? submitZlbBudgetImportPost : submitProjectImport;
      return yield call(serviceReq, payload);
    },
    // 项目导入结果处理
    *handleProjectImportResult({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? resultZlbBudgetImportPost : handleProjectImportResult;
      return yield call(serviceReq, payload);
    },
    // 项目导入模板下载
    *getProjectImportTemplate({ payload }, { call }) {
      const isOtherFunds = window.location.pathname.includes('/claim/otherFunds/project');
      const serviceReq = isOtherFunds ? getTemplateZlbBudgetImportGet : getProjectImportTemplate;
      return yield call(serviceReq, payload);
    },
    *enableProjectLibrary({ payload }, { call }) {
      return yield call(enableProjectLibrary, payload);
    },
    *getProjectLibrarySwitchOpenable({ payload }, { call }) {
      return yield call(getProjectLibrarySwitchOpenable, payload);
    },
    *getProjectLibrarySwitchStatus({ payload }, { call }) {
      return yield call(getProjectLibrarySwitchStatus, payload);
    },
    *relateProjectFinance({ payload }, { call }) {
      return yield call(relateProjectFinance, payload);
    },
    *projectBindVirtualTeam({ payload }, { call }) {
      return yield call(projectBindVirtualTeam, payload);
    },
    *savelBudgetLimitPerson({ payload }, { call }) {
      return yield call(savelBudgetLimitPerson, payload);
    },
    *getBudgetConfig({ payload }, { call, put }) {
      const result = yield call(zlbBudgetConfigProjectScenesConfigListPost, payload);
      yield put({
        type: 'update',
        payload: {
          projectDetailControl: result?.projectDetailControl,
          assistedReportControl: result?.assistedReportControl,
        },
      });
    },

    // 查询当前登录用户所属部门树（包含所有上级部门）
    *getCurrentOperatorDepHierarchy({ payload }, { call }) {
      const result = yield call(getCurrentOperatorDepHierarchy, payload);
      const depList = formatData(result?.depList, 'id', false);
      return depList;
    },

    // 查询包干经费所属部门树
    *getCurrentOperatorFundDepList({ payload }, { call }) {
      const result = yield call(getCurrentOperatorFundDepList, payload);
      const depList = formatData(result?.depList, 'id', false);
      return depList;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
